import React, { useMemo } from 'react';
import styled from 'styled-components';

import { getSales, RejectionData, RejectionReason } from 'apis/merchant-gateway/insights';

import VerticalBarChart, { CurrencyConfig } from '../charts/VerticalBarChart';
import { Legends } from '../charts/types';

type OperationsRejectionsChartProps = {
  legends: Legends<RejectionReason>;
  data: RejectionData<string, RejectionReason>[];
  currency: CurrencyConfig;
  summaryKey: string;
  isVATEnabled: boolean;
};

const OperationsRejectionsChartContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const OperationsRejectionsChart = ({
  legends,
  data,
  currency,
  summaryKey,
  isVATEnabled,
}: OperationsRejectionsChartProps) => {
  const chartData = useMemo(() => {
    return data.map(item => {
      const { label, split: splitByRejectionReason } = item;
      const chartPoint: Record<RejectionReason | 'LOSS', number> = {
        [RejectionReason.AUTOMATIC]: 0,
        [RejectionReason.OTHER]: 0,
        [RejectionReason.VENUE]: 0,
        LOSS: 0,
      };
      splitByRejectionReason?.forEach(({ label, total }) => {
        if (label) {
          chartPoint[label] = total.orders;
        }
        chartPoint.LOSS = getSales(total, isVATEnabled);
      });
      return {
        name: label || '',
        ...chartPoint,
      };
    });
  }, [data, isVATEnabled]);

  return (
    <OperationsRejectionsChartContainer>
      <VerticalBarChart legends={legends} isStacked data={chartData} summaryKey={summaryKey} currency={currency} />
    </OperationsRejectionsChartContainer>
  );
};

export default OperationsRejectionsChart;
